export default "__VITE_ASSET__239Ltu4q__"